import ArticleModel from '../../model/article-model';
import * as URL from '../../utility/url';
import DateFormater from '../../utility/dateformater';
import * as GHPages from '../../config/ghpages';
//import * as Pagination from '../events/pagination';
import {changeLike} from '../../events/liked';
import {getCommentsArticle, getUserAuthBeforeSendComment} from '../../events/comments';
import {shareToMedia} from '../../events/share';
import {isNull,isUndefined,isObject} from 'lodash';
import * as Cookie from '../../services/cookie';

function model() {
    return new ArticleModel('article');
}

function getArticle(id, pattern) {
    let container = document.getElementById(id),
        total = [],
        articleText = "";
    
    if (!isNull(container)) {
        container.innerHTML = `
            <div class="uk-flex uk-flex-center uk-flex-middle uk-height-large">
                <div class="spinner spinner-medium"></div>
            </div>
        `;
    }
    
    model().getArticleOrderBy('like/total').then(snapshot => {
        // deteksi url
        snapshot.forEach(item => {
                        item = item.val();
                        total.push(item);
                        
                        if (total.length < 1) {
                            articleText += 'tidak ada artikel';
                        }
                        articleText += viewArticle(item);
                        container.innerHTML = articleText;
                    });
                    
                    changeLike(model(), snapshot);
                    getToolbarArticle(snapshot);
        // URL.parse('', pattern).then(request => {
            
        //     if (request == GHPages.getOrigin().pathname) {
        //         return false;
        //     } else {
        //         if ((request == '/home'
        //             || request == '/home/index.html'
        //             || request == '/portofolio/home'
        //             || request == '/portofolio/home/index.html')
        //             && !isNull(container)) {
                    
        //             snapshot.forEach(item => {
        //                 item = item.val();
        //                 total.push(item);
                        
        //                 if (total.length < 1) {
        //                     articleText += 'tidak ada artikel';
        //                 }
        //                 articleText += viewArticle(item);
        //                 container.innerHTML = articleText;
        //             });
                    
        //             changeLike(model(), snapshot);
        //             getToolbarArticle();
        //         } else if (request.toString().search(/\?key.*/g) < 1) {
        //             container.innerHTML = "";
                    
        //             return false;
        //         } else {
        //             container.innerHTML = "test"
        //         }
        //     }
        // }).catch(error => {});
        
        
    });
}

function getToolbarArticle(article) {
    let readhide = document.querySelectorAll('.read-hide');
    let readmore = document.querySelectorAll('.read-more');
    
    readmore.forEach((more,key) => {
        let height, moreHeight;
        window.addEventListener('scroll', function(event){
            height = Math.floor(event.target.scrollingElement.scrollTop);
        });
        
        more.addEventListener('click', function(){
            moreHeight = height;
        });
        
        readhide[key].addEventListener('click', function(){
            window.scrollTo(0, moreHeight);
        });
    });
    
    article.forEach(item => {
        var {comments, share, articleTitle, articleUrl, articlePhoto, articleKey} = item.val();
        
        shareToMedia(articleUrl, "website", "wadahkode", articleTitle, articlePhoto);
    });
}

function readMoreWithoutRedirect(str, start, end, key) {
    if (str.length > 100) {
        return `
            <div>
                <div class="toggle-${key}" hidden>
                    <span>${str}</span>
                    <a class="uk-button uk-button-link uk-text-capitalize read-hide" uk-toggle="target: .toggle-${key}">Sembunyikan kembali</a>
                </div>
                <div class="toggle-${key}">
                    <span>${str.substring(start,end)}...</span>
                    <a class="uk-button uk-button-link uk-text-capitalize read-more" uk-toggle="target: .toggle-${key};">tampilkan semuanya</a>
                </div>
            </div>
        `;
    } else {
        return `<div>${str}</div>`;
    }
}

function viewArticle(item) {
    return `
        <div class="uk-card uk-card-default uk-margin-bottom">
            <div class="uk-card-header uk-padding-small">
                <div class="uk-grid-small uk-flex-middle" uk-grid>
                    <div class="uk-width-auto">
                        <img class="uk-border-circle" width="64" height="64" src="${item.photoAuthor}">
                    </div>
                    <div class="uk-width-expand">
                        <h3 class="uk-card-title uk-margin-remove-bottom">${item.author.replace(/@.*/, '').split('.').join(' ')}</h3>
                        <p class="uk-text-meta uk-margin-remove-top"><time datetime="2016-04-01T19:00" class="uk-flex uk-flex-middle">${setCurrentAt(item.created_at)}</time></p>
                    </div>
                </div>
            </div>
            <div class="uk-card-body uk-padding-remove">
                <div uk-lightbox>
                    <a data-href="${item.articlePhoto}" class="uk-inline">
                        <img src="${item.articlePhoto}" class="uk-height-*" alt="" uk-img/>
                    </a>
                </div>
                <!--div class="uk-flex uk-flex-column">
                    <a href="${item.articleUrl}" class="uk-link-reset"><b class="uk-card-title uk-text-capitalize">${item.articleTitle}</b></a>
                    <b class="">@by ${item.author} pada ${item.created_at}</b>
                </div-->
                <div class="uk-padding-small">
                    ${readMoreWithoutRedirect(item.articleContent, 0, 100, item.articleKey)}
                </div>
            </div>
            <div class="uk-card-footer uk-margin-remove-top uk-padding-small toolbar">
                <div class="uk-child-width-1-2 uk-margin-remove-top" uk-grid>
                    <div data-target="${item.articleKey}" class="total-like" hidden>${isObject(item.like) ? item.like.total : 0}&nbsp;suka</div>
                    <div data-target="${item.articleKey}" class="uk-text-right total-share" hidden></div>
                </div>
                <div class="uk-child-width-1-3 uk-margin-small-top" uk-grid>
                    <div>
                        <a class="@uk-icon-button btn-like uk-link-reset" data-target="${item.articleKey}">
                            <span class="heart-dislike" uk-icon="icon: heart; ratio: 1"></span>
                            <span class="label-like">suka</span>
                        </a>
                    </div>
                    <a class="uk-link-reset btn-comment" uk-toggle="target: #comments-${item.articleKey}; animation: uk-animation-fade">
                        <span uk-icon="icon: comments; ratio: 1"></span>
                        <span>&nbsp;komentar</span>
                    </a>
                    <a class="uk-link-reset uk-text-right" uk-toggle="target: #share-${item.articleKey}">
                        <span uk-icon="icon: forward; ratio: 1"></span>
                        <span>&nbsp;bagikan</span>
                    </a>
                    <div id="share-${item.articleKey}" uk-modal>
                        <div class="uk-modal-dialog uk-modal-body uk-position-bottom uk-flex uk-flex-center uk-flex-middle uk-flex-between uk-flex-wrap">
                            <div class="fb-share-button" data-href="https://developers.facebook.com/docs/plugins/" data-layout="box_count">
                                <a class="btn-share-facebook uk-text-center uk-link-reset uk-flex uk-flex-center uk-flex-column uk-flex-wrap">
                                    <span uk-icon="icon: facebook; ratio: 1.5"></span>
                                    <span>Facebook</span>
                                </a>
                            </div>
                            <div>
                                <a target="_blank" class="btn-share-whatsapp uk-text-center uk-link-reset uk-flex uk-flex-center uk-flex-column uk-flex-wrap">
                                    <span uk-icon="icon: whatsapp; ratio: 1.5"></span>
                                    <span>Whatsapp</span>
                                </a>
                            </div>
                            <div>
                                <a target="_blank" class="btn-share-twitter uk-text-center uk-link-reset uk-flex uk-flex-center uk-flex-column uk-flex-wrap">
                                    <span uk-icon="icon: twitter; ratio: 1.5"></span>
                                    <span>Twitter</span>
                                </a>
                            </div>
                            <div>
                                <a data-href="${item.articleUrl}" class="btn-copy-url uk-text-center uk-link-reset uk-flex uk-flex-center uk-flex-column uk-flex-wrap">
                                    <span uk-icon="icon: copy; ratio: 1.5"></span>
                                    <span><input class="copied" value="${item.articleUrl}" hidden></span>
                                    <span class="copied-message">Salin</span>
                                </a>
                            </div>
                            <!--p>Maaf, masih dalam tahap pengembangan, mohon untuk menunggu...</p-->
                        </div>
                    </div>
                </div>
            </div>
            <div id="comments-${item.articleKey}" class="uk-card uk-card-body uk-margin-top uk-padding-small" hidden>
                <form>
                    <div class="uk-margin">
                        <textarea class="uk-textarea" rows="3" placeholder="berikan komentar anda..."></textarea>
                    </div>
                    <div class="uk-margin">
                        <button type="button" class="uk-button uk-button-small uk-button-primary quick-btn-comment">Komentar</button>
                    </div>
                </form>
            </div>
        </div>
    `;
}

function setCurrentAt(d) {
    let date = new DateFormater(new Date()),
        currentAt = date.setCurrentAt(d);
        
    if (isObject(currentAt)) {
        return date.setTimeCronJob(distance => {
            if (distance < 1) {
                console.log(currentAt.seconds);
                //return `<span>${currentAt.seconds}</span>`;
            }
        });
    }
    return (currentAt);
}

export {getArticle};